import { useEffect, useState } from 'react';
import { axiosPrivate } from '../axios';
import { apiSubscription } from '../api/apiSubscription.api';

export function useSubscription() {
  const [subs, setSubs] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    apiSubscription
      .activeSub(axiosPrivate)
      .then((res) => setSubs(res))
      .finally(() => setIsLoading(false));
  }, []);


  return { subs, subscription: subs?.tire, isActiveSubscription: subs?.isActive, isLoading };
}
